let asyncDataLayer = {};
export const getAdblockInfo = function (callback) {
    // var xhr = new XMLHttpRequest();
    // xhr.open("GET", "https://static.fr.shopping.rakuten.com/visuels/0_content_square/adblockersDetection/ads.js?ad_box_=1&adunit=1&callback=rakutenAdblockerCallback");
    // xhr.setRequestHeader("Content-Type", "application/javascript");
    // xhr.timeout = 500;
    // xhr.onerror = function () {
    //     callback("Oui");
    // };
    // xhr.onload = function () {
    //     callback("Non");
    // };
    // xhr.ontimeout = function () {
    //     callback("Non");
    // };
    // xhr.send();
    callback('Non');
};
export const getCustomDataLayer = function (PMContext) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const data = {};
    PMContext = PMContext || {};
    // Pseudo
    data['userID'] = PMContext.uid || PMContext.user_id || PMContext.userId;
    // Connecté ou pas
    data['logged'] = 'Non';
    if (data['userID']) {
        data['logged'] = 'Oui';
    }
    data['clubMemberStatus'] = PMContext.club_member_status || PMContext.clubR;
    if (!data['clubMemberStatus']) {
        data['clubMemberStatus'] = 'UNSUBSCRIBED';
    }
    // Pro ou Part
    if (PMContext.pro == '1') {
        data['userType'] = 'PRO';
    }
    else if (PMContext.pro == '0') {
        data['userType'] = 'PART';
    }
    else {
        data['userType'] = '';
    }
    // Catégories
    let categories = '';
    try {
        categories = PMContext.categories || PMContext.category_url;
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    try {
        categories = categories || ((_c = (_b = (_a = document === null || document === void 0 ? void 0 : document.location) === null || _a === void 0 ? void 0 : _a.hash) === null || _b === void 0 ? void 0 : _b.match(/nav=([_-a-zA-Z0-9]*)/i)) === null || _c === void 0 ? void 0 : _c[1]);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    try {
        categories = categories || ((_f = (_e = (_d = document === null || document === void 0 ? void 0 : document.location) === null || _d === void 0 ? void 0 : _d.search) === null || _e === void 0 ? void 0 : _e.match(/nav=([_-a-zA-Z0-9]*)/i)) === null || _f === void 0 ? void 0 : _f[1]);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    try {
        categories = categories || ((_j = (_h = (_g = document === null || document === void 0 ? void 0 : document.location) === null || _g === void 0 ? void 0 : _g.pathname) === null || _h === void 0 ? void 0 : _h.match(/^\/nav\/([_-a-zA-Z0-9]*)/i)) === null || _j === void 0 ? void 0 : _j[1]);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
    let categoriesArray = [];
    if (categories) {
        if (typeof categories !== 'object') {
            categoriesArray = categories.replace(/,/g, '_').split('_');
        }
        data['categorie'] = categoriesArray[0] || '';
        data['sousCategorie'] = categoriesArray[1] || '';
        data['sousSousCategorie'] = categoriesArray[2] || '';
    }
    // Mobile ou desktop
    if (navigator.userAgent.indexOf('Mobile') + 1) {
        data['device'] = 'MOBILE';
    }
    else
        data['device'] = 'DESKTOP';
    // Extension
    const extension_crew_installed = document.querySelector('extension-info[id="rakuten-club-extension"]') ? 'Oui' : 'Non';
    data['extension_crew_installed'] = extension_crew_installed;
    // TODO wher does this value get incremented?
    // Nombre de page vues
    data['nombre_pages_vues'] = sessionStorage.getItem('pagesViewed');
    // @ts-expect-error TODO: fix this
    // eslint-disable-next-line  @typescript-eslint/no-unused-expressions
    data['nombre_pages_vues'] >= 6 ? (data['nombre_pages_vues'] = 'superieur_5') : false;
    // Envoi du type de page
    if (/^\/(s|search)\//i.test(document.location.pathname))
        data['pageType'] = 'SEARCH';
    else if (/^\/nav\//i.test(document.location.pathname))
        data['pageType'] = 'NAV';
    else if (document.location.pathname === '/')
        data['pageType'] = 'HOME';
    else if (document.querySelector('.shopPro') ||
        // eslint-disable-next-line no-useless-escape
        /\/offer\?action=desc\&aid=/i.test(document.location.pathname + document.location.search) ||
        // eslint-disable-next-line no-useless-escape
        /\/mfp\/shop\//i.test(document.location.pathname) ||
        // eslint-disable-next-line no-useless-escape
        /\/offer\/shop\//i.test(document.location.pathname) ||
        // eslint-disable-next-line no-useless-escape
        /\/boutique\//i.test(document.location.pathname))
        data['pageType'] = 'SUPER_BOUTIQUE';
    // eslint-disable-next-line no-useless-escape
    else if (/(^\/offer\/buy\/)|(^\/mfp\/)/i.test(document.location.pathname))
        data['pageType'] = 'FP';
    // eslint-disable-next-line no-useless-escape
    else if (/^\/v\/vendre/i.test(document.location.pathname))
        data['pageType'] = 'SELL';
    // eslint-disable-next-line no-useless-escape
    else if (/^\/event\//i.test(document.location.pathname))
        data['pageType'] = 'EVENT';
    else if (
    // eslint-disable-next-line no-useless-escape
    /^(\/user$)|(\/memo\?action=list)|(\/purchase\?action=buylist)|(\/purchase\?action=itemmonitoring\&itemid=)|(\/usersecure\?action=rakutenclubhistory)|(\/usersecure\?action=clubaccount)/i.test(document.location.pathname + document.location.search))
        data['pageType'] = 'MON_COMPTE';
    else
        data['pageType'] = 'OTHER';
    // Envoi du mot clé
    data['keyword'] = '';
    data['keyword'] =
        // eslint-disable-next-line no-useless-escape
        ((_k = /^\/s\/([%\+a-z0-9]*)/i.exec(document.location.pathname)) === null || _k === void 0 ? void 0 : _k[1]) ||
            (
            // eslint-disable-next-line no-useless-escape
            (_l = /^\/search\/([%\+a-z0-9]*)/i.exec(document.location.pathname)) === null || _l === void 0 ? void 0 : _l[1]) ||
            (
            // eslint-disable-next-line no-useless-escape
            (_o = (_m = /^\/mfp\/[0-9]*\/([-a-z0-9]*)/i.exec(document.location.pathname)) === null || _m === void 0 ? void 0 : _m[1]) === null || _o === void 0 ? void 0 : _o.replace(/-/g, '+')) ||
            (
            // eslint-disable-next-line no-useless-escape
            (_q = (_p = /^\/offer\/buy\/[0-9]*\/([-a-z0-9]*)/i.exec(document.location.pathname)) === null || _p === void 0 ? void 0 : _p[1]) === null || _q === void 0 ? void 0 : _q.replace(/-/g, '+').replace('.html', '')) ||
            '';
    // Product ID
    data['productID'] = '';
    const productID = /^\/offer\/buy\/([0-9]*)/i.exec(document.location.pathname) ||
        /^\/mfp\/.*\?pid=([0-9]*)/i.exec(document.location.pathname + document.location.search) ||
        /^\/offer\?action=desc.*productid=([0-9]*)/i.exec(document.location.pathname + document.location.search);
    if (productID)
        data['productID'] = productID[1] || '';
    // Envoi de l'URL
    data['url'] = document.location.pathname;
    // Etat
    if (/\/(s|search|nav).*ft=n/i.test(document.location.href) || (data['pageType'] === 'FP' && /filter=10/i.test(document.location.search)))
        data['etat'] = 'Neuf';
    else if (/\/(s|search|nav).*ft=u/i.test(document.location.href) ||
        (data['pageType'] === 'FP' && /filter=20/i.test(document.location.search)))
        data['etat'] = 'Occasion';
    else if (/\/(s|search|nav).*ft=r/i.test(document.location.href) ||
        (data['pageType'] === 'FP' && /filter=40/i.test(document.location.search)))
        data['etat'] = 'Reconditionne';
    return data;
};
export const isDisplayed = function (programmation) {
    let prog = false;
    programmation.forEach(function (i) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        i.start[1].length === 4 ? (i.start[1] = '0' + i.start[1]) : null;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        i.end[1].length === 4 ? (i.end[1] = '0' + i.end[1]) : null;
        let dateDuJour = new Date();
        // @see I assume this simulation date is from extension Rakuten merchandising extension https://chromewebstore.google.com/detail/rakuten-merchandising-ext/dliblbmghmiciihcambmgbfgpooplkmj
        // @ts-expect-error simulation Date
        if (window.simulationDate)
            dateDuJour = new Date(simulationDate);
        prog =
            prog ||
                (new Date(i.start[0] + 'T' + i.start[1] + ':00').getTime() < dateDuJour.getTime() &&
                    new Date(i.end[0] + 'T' + i.end[1] + ':00').getTime() > dateDuJour.getTime());
    });
    return prog;
};
export const getAsyncDataLayer = function (callback, refresh) {
    const data = {};
    if (!refresh && asyncDataLayer) {
        callback(asyncDataLayer);
        return true;
    }
    getAdblockInfo(function (adblocker) {
        // PM.Context
        if (typeof window.PM !== 'undefined' && window.PM.Context && window.PM.Context.data) {
            Object.keys(window.PM.Context.data).forEach(function (key) {
                if (window.PM.Context.data[key].criteria) {
                    data[key] = window.PM.Context.data[key].value;
                }
            });
            close(data);
        }
        else if (typeof window.dataLayer != 'undefined' && window.dataLayer[0]) {
            Object.assign(data, window.dataLayer.find((e) => e.userId !== undefined));
            close(data);
        }
        else {
            // Et sur mobile
            if (typeof window.PMContext !== 'undefined') {
                Object.assign(data, window.PMContext);
                close(data);
            }
        }
        function close(data) {
            Object.assign(data, getCustomDataLayer(data));
            data['adblocker'] = adblocker;
            asyncDataLayer = data;
            callback(data);
            return true;
        }
    });
};
export const getFilteredCampaigns = function (incomingCampaigns, global) {
    return new Promise((resolve) => {
        getAsyncDataLayer(function (asyncDataLayer) {
            const campaigns = incomingCampaigns.filter(function (campaign) {
                let filter = true;
                Object.keys(campaign.targeting).forEach(function (e) {
                    var _a, _b;
                    if (e === 'keyword') {
                        let matchCount = 0;
                        (_a = campaign === null || campaign === void 0 ? void 0 : campaign.targeting[e]) === null || _a === void 0 ? void 0 : _a.forEach(function (keyword) {
                            if (asyncDataLayer[e].indexOf(keyword) !== -1) {
                                matchCount++;
                            }
                        });
                        if (matchCount === 0)
                            filter = false;
                        return;
                    }
                    if (e === 'ExcludeUrl') {
                        if ((_b = campaign === null || campaign === void 0 ? void 0 : campaign.targeting[e]) === null || _b === void 0 ? void 0 : _b.includes(asyncDataLayer['url'])) {
                            filter = false;
                        }
                        return;
                    }
                    if (!campaign.targeting[e].includes(asyncDataLayer[e])) {
                        filter = false;
                    }
                });
                const lastDisplayDate = localStorage.getItem('merchandising-campaign-' + campaign.id);
                const daysSinceLastDisplay = (new Date().getTime() - new Date(lastDisplayDate || '').getTime()) / 86400000;
                if (lastDisplayDate && campaign.expositionLimitDays !== 0 && daysSinceLastDisplay < campaign.expositionLimitDays) {
                    filter = false;
                }
                filter = filter && isDisplayed(campaign.programmation);
                return filter;
            });
            if (global) {
                resolve(campaigns);
                return;
            }
            const selectedCampaigns = [];
            if (campaigns.length) {
                const highestPriority = Math.min(...campaigns.map((c) => c.priority));
                for (const campaign of campaigns) {
                    if (campaign.priority === highestPriority) {
                        selectedCampaigns.push(campaign);
                    }
                }
            }
            const selectedCampaign = selectedCampaigns[Math.floor(Math.random() * selectedCampaigns.length)];
            if (selectedCampaign && selectedCampaign.expositionLimitDays !== 0) {
                localStorage.setItem('merchandising-campaign-' + selectedCampaign.id, new Date().toISOString());
            }
            resolve(selectedCampaign);
        }, true);
    });
};
// 사용 예시:
// const campaign = await getFilteredCampaigns(campaigns, false);
